export default __webpack_public_path__ + "static/media/score2.4912be16.svg";